import React, { useState, useEffect } from "react";
import { postDataAPI } from "../../hooks/fetchApi";
import { status } from "../../features";
import { useDispatch } from "react-redux";
import _ from "lodash";
import { formatDateTime } from "../../utils/utils";
import AddPayment from "./add-payment";

function Payments() {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(10);
  const [param, setParam] = useState({
    is_all: true,
    is_credit: true
  });


  const addPayment = () => {
    getData();
  };
  const getData = () => {
    dispatch(status.setStatus(true));
    postDataAPI({
      service: "investor_payments",
      data: param,
    }).then((data) => {
      dispatch(status.setStatus(false));
      if (data.success === 1) {
        setData(data.data);
        setTotal(data.items);
      }
    });
  };


  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="p-4 bg-white rounded-md">

      <div className="flex justify-between">
        <p>Payments </p>
        <AddPayment addPayment={addPayment} />
      </div>
      <div className="overflow-x-auto">
        <table>
          <thead>
            <tr>
              <th>No</th>
              <th>Name</th>
              <th>Amount($)</th>
              <th>Added on</th>
            </tr>
          </thead>

          <tbody>
            {_.map(data, (d, i) => (
              <tr key={i}>
                <td>{i + 1}</td>
                <td>
                  {d.first_name} {d.last_name}
                </td>
                <td>{d.amount}</td>
                <td>{formatDateTime(d.creation_datetime)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
}

export default Payments;
